export interface EvidenceMappingRow {
  controlId: string;
  evidencePath: string;
  evidenceType: string;
  notes: string;
}

// Mirrors the public sample evidence pack (marketing/public/downloads/evidence-pack.zip)
export const SAMPLE_EVIDENCE_MAPPING_INDEX: EvidenceMappingRow[] = [
  {
    controlId: "VE-C01",
    evidencePath: "evidence/device_export_sample.csv",
    evidenceType: "device_inventory",
    notes: "Sample CSV export scoped by site_id."
  },
  {
    controlId: "VE-C05",
    evidencePath: "checksums.sha256",
    evidenceType: "integrity",
    notes: "Per-file hashes (verify with sha256sum -c)."
  },
  {
    controlId: "VE-C06",
    evidencePath: "evidence/audit_log_excerpt.json",
    evidenceType: "audit_log_excerpt",
    notes: "Redacted sample format (non-PII)."
  },
  {
    controlId: "VE-C10",
    evidencePath: "evidence/continuity_log.json",
    evidenceType: "continuity_log",
    notes: "Offline/backfill structure and integrity flag."
  },
  {
    controlId: "VE-C11",
    evidencePath: "evidence/continuity_log.json",
    evidenceType: "continuity_log",
    notes: "Backfill and gap fields; sample shows verified integrity."
  },
  {
    controlId: "VE-C12",
    evidencePath: "EVIDENCE_PACK_INDEX.json",
    evidenceType: "pack_index",
    notes: "Index lists included files and verification steps."
  },
  {
    controlId: "VE-C13",
    evidencePath: "CONTROL_MAPPING_INDEX.csv",
    evidenceType: "control_mapping_index",
    notes: "Maps controls to included artifacts."
  }
];
